import { Component, effect, inject, input, output } from '@angular/core';

import { Observable, combineLatest } from 'rxjs';
import { filter, map, startWith, switchMap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { Location, Room } from '@era/locations-sdk';

import { AsyncPipe } from '@angular/common';
import { toObservable } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { CategoryStoreActions, CategoryStoreSelectors, DeviceStoreSelectors } from '@era/stores';
import { RoomSelectComponent } from './room-select.component';
@Component({
  selector: 'era-room-select',
  templateUrl: './room-select.container.html',
  imports: [RoomSelectComponent, ReactiveFormsModule, AsyncPipe],
})
export class RoomSelectContainerComponent {
  private readonly store = inject(Store);

  readonly location = input.required<Location>();

  readonly roomChange = output<Room>();

  public readonly showRoomsWithDevicesForm: UntypedFormControl = new UntypedFormControl(false);
  public readonly rooms$: Observable<Room[]>;

  constructor() {
    const _location$ = toObservable(this.location);
    const showRoomsWithDevices$: Observable<boolean> = this.showRoomsWithDevicesForm.valueChanges.pipe(
      startWith(this.showRoomsWithDevicesForm.value),
      map((show) => (show ? true : false))
    );

    this.rooms$ = combineLatest([_location$, showRoomsWithDevices$]).pipe(
      filter(([location]) => !!location),
      switchMap(([location, withDevices]) =>
        withDevices
          ? this.store.select(CategoryStoreSelectors.selectRoomsByLocationId(location.id))
          : this.store.select(DeviceStoreSelectors.selectRoomsByLocationWithoutAnyDevice(location.id))
      )
    );

    effect(() => {
      const location = this.location();
      if (!location) return;

      this.store.dispatch(
        CategoryStoreActions.CategoryResolverActions.categoriesRequested({
          categoryType: 'Room',
          locationId: location.id,
        })
      );
    });
  }

  selected(room: Room) {
    this.roomChange.emit(room);
  }
}
